module.exports = {
  WEAK: 0,
  AVERAGE: 1,
  STRONG: 2,
}